// Traduções da faixa do Protheus — coletadas por glob em core/i18n/messages.ts.
export default {
  pt: {
    'protheus.banner.lastSync': 'Última sincronização',
    'protheus.banner.vehicles': 'Veículos',
    'protheus.banner.drivers': 'Motoristas',
    'protheus.banner.created': 'Criados',
    'protheus.banner.updated': 'Atualizados',
    'protheus.banner.unchanged': 'Sem mudança',
    'protheus.banner.outOfCycle': 'Fora do ciclo',
  },
  en: {
    'protheus.banner.lastSync': 'Last sync',
    'protheus.banner.vehicles': 'Vehicles',
    'protheus.banner.drivers': 'Drivers',
    'protheus.banner.created': 'Created',
    'protheus.banner.updated': 'Updated',
    'protheus.banner.unchanged': 'Unchanged',
    'protheus.banner.outOfCycle': 'Out of cycle',
  },
  es: {
    'protheus.banner.lastSync': 'Última sincronización',
    'protheus.banner.vehicles': 'Vehículos',
    'protheus.banner.drivers': 'Conductores',
    'protheus.banner.created': 'Creados',
    'protheus.banner.updated': 'Actualizados',
    'protheus.banner.unchanged': 'Sin cambios',
    'protheus.banner.outOfCycle': 'Fuera del ciclo',
  },
}
